// Import general mixin for shared functionality.
import mixin from './mixin';

// Fuzzy search module
import Fuse from 'fuse.js';

const fuseOptions = {
    shouldSort: false,
    keys: [
        'Name',
        'Synoniemen',
        'Snippet',
    ]
};

const drugsOverviewApp = {
    mixins: [mixin],
    data() {
        return {
            dataJson: null,
            searchText: '',
        }
    },
    computed: {
        filteredItems() {
            if (!this.dataJson) return [];
            if (!this.searchText) return this.dataJson;
            const fuse = new Fuse(this.dataJson, fuseOptions);
            let results = fuse.search(this.searchText);
            return results.map(result => result.item).sort((a, b) => a.Name - b.Name);
        },
    },
    methods: {
        firstChar(currItem) {
            if (!currItem || !currItem.Name) return null;
            let index = this.filteredItems.findIndex(item => item.Id === currItem.Id);
            let prevItem = this.filteredItems[index - 1];
            if (!prevItem || (prevItem.Name && Array.from(prevItem.Name)[0] !== Array.from(currItem.Name)[0])) {
                return Array.from(currItem.Name)[0];
            } else {
                return null;
            }
        },
    },
    created() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        if (urlParams.has('q')) this.searchText = urlParams.get('q');

        this.changeSearchText = this.debounce(event => {
            const url = new URL(location);
            url.searchParams.set('q', this.searchText);
            if (!this.searchText) url.searchParams.delete('q');
            history.pushState({}, '', url);
        });
    },
    mounted() {
        if (this.$el.dataset.json) this.dataJson = JSON.parse(this.$el.dataset.json);
    },
};

export default drugsOverviewApp;
